module.exports = __webpack_public_path__ + "img/new-construction-min.88628e1e.jpg";